A partner-provided unique ID for the component.

This can be used to correlate the component back to its corresponding representation in your software.
